@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.modal-body {
  line-height: 1.5;
  padding: 20px;
  word-wrap: normal;
  padding-bottom: 50px;
}

.step-content {
  width: 100%;
}

.header {
  font-size: 20px;
  color: @wallet--header--text-color;
  padding-top: 6px;
  padding-bottom: 12px;
  line-height: 25px;
}
.sub-header {
  font-size: 16px;
  font-weight: 800;
  padding-bottom: 8px;
}

.list-items {
  display: list-item;
  line-height: 25px;
  font-size: 16px;
  list-style-type: disc;
  list-style-position: outside;
  margin-left: 20px;
}
